import NeedleAnalytic from "@/lib/Needle";

export const needleAnalytic = new NeedleAnalytic();
